import { FormControlLabel, Stack, Switch, TextField } from "@mui/material";
import type { NumberFormatterOptions } from "../../../../../../../../../api/types/fieldConfigurationTypes";
import type { CurrencyDimensionMeta } from "../../../../../../../../../api/types/svTypes";
import FormatSelect from "../../FormatSelect";

interface Props {
  name: string;
  nameError?: string;
  format?: NumberFormatterOptions;
  blankIfMissingValue: boolean;
  currencyDimensions?: CurrencyDimensionMeta[];
  onNameChange: (value: string) => void;
  onNameBlur: () => void;
  onFormatChange: (value: NumberFormatterOptions | undefined) => void;
  onBlankIfMissingValueChange: (value: boolean) => void;
}

const CustomFormulaDefinitionPanel = ({
  name,
  nameError,
  format,
  blankIfMissingValue,
  currencyDimensions,
  onNameChange,
  onNameBlur,
  onFormatChange,
  onBlankIfMissingValueChange,
}: Props) => {
  return (
    <Stack spacing={2} sx={{ p: 2.5 }}>
      <TextField
        label="Name"
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
        onBlur={onNameBlur}
        error={nameError !== undefined}
        helperText={nameError}
        fullWidth
      />
      <FormatSelect
        format={format}
        label="Number Format"
        currencyDimensions={currencyDimensions}
        onUpdateFormatter={onFormatChange}
        disabled={false}
      />
      <FormControlLabel
        control={
          <Switch
            checked={blankIfMissingValue}
            onChange={(event) => onBlankIfMissingValueChange(event.target.checked)}
          />
        }
        label="Blank if any value is missing"
      />
    </Stack>
  );
};

export default CustomFormulaDefinitionPanel;
